(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["taildash-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('taildash-faq')) {
    customElements.define('taildash-faq', class extends HTMLElement {
      connectedCallback() {
        if (!window.Shopify?.designMode || this.editorEvents) return;
        this.editorEvents = new AbortController();
        this.addEventListener('shopify:block:select', (event) => {
          const item = event.target.closest('.taildash-faq__item');
          if (item && this.contains(item)) item.open = true;
        }, { signal: this.editorEvents.signal });
      }

      disconnectedCallback() {
        this.editorEvents?.abort();
        this.editorEvents = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["taildash-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('taildash-hero')) {
    customElements.define('taildash-hero', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.video = this.querySelector('video');
        if (!this.video) return;

        this.controller = new AbortController();
        const { signal } = this.controller;
        const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.video.loop = true;
        this.video.playsInline = true;
        this.video.controls = false;

        const updatePlayback = () => {
          this.video.autoplay = !motion.matches;
          if (motion.matches) this.video.pause();
          else if (!document.hidden) this.playVideo();
        };

        motion.addEventListener('change', updatePlayback, { signal });
        document.addEventListener('visibilitychange', updatePlayback, { signal });
        this.video.addEventListener('canplay', updatePlayback, { signal, once: true });
        updatePlayback();
      }

      playVideo() {
        const playRequest = this.video.play();
        if (playRequest) playRequest.catch(() => {});
      }

      disconnectedCallback() {
        if (this.controller) this.controller.abort();
        this.controller = null;
        if (this.video) this.video.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["taildash-video-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('taildash-video-carousel')) {
    customElements.define(
      'taildash-video-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.initialFrame = requestAnimationFrame(() => this.initialize());
        }

        disconnectedCallback() {
          cancelAnimationFrame(this.initialFrame);
          this.events?.abort();
          this.resizeObserver?.disconnect();
          this.blockObserver?.disconnect();
        }

        initialize() {
          if (!this.isConnected) return;
          this.track = this.querySelector('.taildash-videos__track');
          if (!this.track) return;

          this.events?.abort();
          this.events = new AbortController();
          const signal = this.events.signal;
          this.buttons = Array.from(this.querySelectorAll('.taildash-videos__arrow'));

          this.buttons.forEach((button) => {
            button.addEventListener('click', () => this.move(Number(button.dataset.direction)), { signal });
          });

          this.track.addEventListener(
            'keydown',
            (event) => {
              if (event.target !== this.track) return;
              const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
              if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
                event.preventDefault();
                this.move((event.key === 'ArrowRight' ? 1 : -1) * direction);
              } else if (event.key === 'Home' || event.key === 'End') {
                event.preventDefault();
                this.scrollToPosition(event.key === 'Home' ? 0 : this.maximumScroll);
              }
            },
            { signal }
          );

          document.addEventListener(
            'shopify:block:select',
            (event) => {
              const card = Array.from(this.track.children).find((item) => item.dataset.blockId === event.detail.blockId);
              if (card) this.scrollToPosition(this.cardPosition(card), 'auto');
            },
            { signal }
          );

          this.resizeObserver = new ResizeObserver(() => this.updateArrows());
          this.resizeObserver.observe(this.track);
          this.blockObserver = new MutationObserver(() => this.updateArrows());
          this.blockObserver.observe(this.track, { childList: true });
          this.updateArrows();
        }

        get maximumScroll() {
          return Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        }

        get isRtl() {
          return getComputedStyle(this.track).direction === 'rtl';
        }

        cardPosition(card) {
          const first = this.track.firstElementChild;
          if (!first) return 0;
          const offset = this.isRtl ? first.offsetLeft - card.offsetLeft : card.offsetLeft - first.offsetLeft;
          return Math.min(this.maximumScroll, Math.max(0, offset));
        }

        move(direction) {
          if (this.maximumScroll <= 2) return;
          const current = Math.max(0, this.isRtl ? -this.track.scrollLeft : this.track.scrollLeft);
          const positions = Array.from(new Set(Array.from(this.track.children, (card) => this.cardPosition(card))));
          const next = direction > 0
            ? positions.find((position) => position > current + 2) ?? 0
            : positions.reverse().find((position) => position < current - 2) ?? this.maximumScroll;
          this.scrollToPosition(next);
        }

        scrollToPosition(position, behavior) {
          const target = Math.min(this.maximumScroll, Math.max(0, position));
          const motion = behavior || (matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth');
          this.track.scrollTo({ left: this.isRtl ? -target : target, behavior: motion });
        }

        updateArrows() {
          const hasOverflow = this.maximumScroll > 2;
          this.buttons.forEach((button) => { button.hidden = !hasOverflow; });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
